module.exports = __webpack_public_path__ + "img/FB_Info_Game_Page_3.174945c8.png";